import { render } from "./BookDetailsRightPanel.vue?vue&type=template&id=3349a732&scoped=true"
import script from "./BookDetailsRightPanel.vue?vue&type=script&lang=js"
export * from "./BookDetailsRightPanel.vue?vue&type=script&lang=js"

import "./BookDetailsRightPanel.vue?vue&type=style&index=0&id=3349a732&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3349a732"]])

export default __exports__